module.exports = __webpack_public_path__ + "img/premiation-3-panela-eletrica.598b70bb.png";